var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-title',{staticClass:"font-weight-normal mt-2"},[_vm._v("\n    "+_vm._s(_vm.$t('profile_picture'))+"\n  ")]),_c('image-uploader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }